
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {baseUrl, formatDate, limit} from "../../../comman/config";
import { can } from "../../../comman/permissions";
import { useNavigate, Link } from 'react-router-dom';
// import Pagination from "react-js-pagination";

function List() {

    const [ItemList, setItemList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [statusFilter, setStatusFilter] = useState('active'); // 'all' | 'active' | 'deactive'
    // Both bound against the event's OWN dates: Start Date keeps events starting on or after it,
    // End Date keeps events ending on or before it. Together they read as "events inside this
    // window". Compared as YYYY-MM-DD strings, which sort chronologically.
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        getItems();
        
    }, [statusFilter]);

    // ItemList is a dependency too: it used to be seeded straight from the fetch, so a date filter
    // set before a refetch would have been dropped the moment the status filter reloaded the list.
    useEffect(() => {
        const query = searchQuery.trim().toLowerCase();
        setFilteredList(ItemList.filter((item) => {
            const matchesName = !query || (item.event_name ?? '').toLowerCase().includes(query);
            const matchesStart = !startDate || String(item.start_date ?? '') >= startDate;
            const matchesEnd = !endDate || String(item.end_date ?? '') <= endDate;
            return matchesName && matchesStart && matchesEnd;
        }));
    }, [searchQuery, startDate, endDate, ItemList]);
    const getItems = async () => {
        // console.log(page);
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/event/list?page=${page}&limit=${limit}&status=${statusFilter}`, {
           
        });
        setPopupOpen(false);
        const sortedData = response.data.data.sort((a, b) => {
            return new Date(b.start_date) - new Date(a.start_date);
          });
        setItemList(sortedData);
        setTotalItem(response.data.totalItem);
    }

    const handelFilterChange= (e) => {
        const { value } = e.target;
        setSearchQuery(value);
    };

    const userRole = String(localStorage.getItem('userRole'));
    // Disable and Enable are admin actions per spec -- this used to be superadmin-only. Both are
    // reversible and there is no hard delete for an event, so nothing here is irreversible.
    // Which buttons this user gets is Role Master's call now, not a role number's -- see
    // comman/permissions.js.
    const canDisable = can('disable');
    const canActivate = can('active');
    const canDelete = can('delete');

    const handleClear = () => {
        setSearchQuery('');
        setStartDate('');
        setEndDate('');
        setStatusFilter('active');
    };

    // Delete removes the row, unlike Disable which is recoverable, so its confirmation says so.
    // Whether a menu or a raw-material plan still names the event is the backend's call -- it
    // counts them and refuses with the reason, which is what gets shown here.
    const destroyMenuitem = async (id) => {
        if (!window.confirm('Permanently DELETE this event? Disable is reversible; this is not.')) return;
        try {
            await axios.delete(`${baseUrl}/event/destroy/${id}`, { data: { role: userRole } });
            window.location.reload();
        } catch (error) {
            alert(error?.response?.data?.msg ?? 'Failed to delete the event.');
        }
    };

    const enableMenuitem = async (id) => {
        if (!window.confirm('Enable this event?')) return;
        try {
            await axios.post(`${baseUrl}/event/enable/${id}`, { role: userRole });
            window.location.reload();
        } catch (error) {
            alert(error?.response?.data?.msg ?? 'Failed to enable the event.');
        }
    };

    const deleteMenuitem = async (id) => {
        if (!canDisable) {
            alert('Only an admin is allowed to disable an event.');
            return;
        }
        // Two-step confirmation: an event is what every other screen files its work under, so
        // taking one out of the active list is worth asking twice about, even though Disable is
        // reversible and Delete -- which is not -- is a separate button above.
        //
        // "Disable", not "remove", in both: the button says Disable, the row stays and can be
        // enabled again, and a prompt that says removed reads like the one action here that
        // cannot be undone. It is also how every other master words this.
        const firstConfirm = window.confirm('Are you sure you want to disable this event?');
        if (!firstConfirm) return;
        const secondConfirm = window.confirm('This event will be disabled and taken off the active list. Are you sure you want to proceed?');
        if (!secondConfirm) return;
        try {
            await axios.delete(`${baseUrl}/event/delete/${id}`, {
                data: { role: userRole },
            });
            window.location.reload();
        } catch (error) {
            const msg = error?.response?.data?.msg || 'Failed to disable the event.';
            alert(msg);
            console.log(error);
        }
    };

    const editMenuitem = async (id) => {
        navigate(`/event_master/edit/${btoa(id)}`, { state: ItemList.filter(item => item.id == id) });
    }

   


    return (
        <div className="p-4">
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-2xl font-bold">Event Master</h1>
                <div>
                    <Link to="/event_master/add">
                        <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Event</button>
                    </Link>
                </div>
            </div>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                <div className="pb-4 flex flex-col sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center justify-between">
                    <label htmlFor="table-search" className="sr-only">Search</label>

                    {/* Search and Dropdown Container */}
                    <div className="flex items-center gap-4">
                        {/* Search Input */}
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 flex items-center ps-3 pointer-events-none">
                                <svg className="w-5 h-5 text-gray-500 dark:text-gray-400" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                                </svg>
                            </div>
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={handelFilterChange}
                                id="table-search"
                                className="block p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                placeholder="Event Name"
                            />
                        </div>

                        {/* Start Date / End Date, against the event's own dates. */}
                        <label className="text-sm text-gray-700" htmlFor="event-start">Start Date</label>
                        <input
                            id="event-start"
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            className="p-2 border rounded-lg text-sm focus:ring-blue-500 focus:border-blue-500"
                        />
                        <label className="text-sm text-gray-700" htmlFor="event-end">End Date</label>
                        <input
                            id="event-end"
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            className="p-2 border rounded-lg text-sm focus:ring-blue-500 focus:border-blue-500"
                        />

                        {/* Status. The values are what /event/list expects; only the labels change,
                            to the Active / Inactive wording the other master lists use. */}
                        <select
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            className="p-2 border rounded-lg text-sm focus:ring-blue-500 focus:border-blue-500"
                        >
                            <option value="all">All</option>
                            <option value="active">Active</option>
                            <option value="deactive">Inactive</option>
                        </select>

                        <button
                            onClick={handleClear}
                            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
                        >
                            Clear
                        </button>
                    </div>
                </div>
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" className="px-6 py-3">Event name</th>
                            <th scope="col" className="px-6 py-3">Start Date</th>
                            <th scope="col" className="px-6 py-3">End Date</th>
                            <th scope="col" className="px-6 py-3">Event Blow Type</th>
                            <th scope="col" className="px-6 py-3">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                    {filteredList.map((item) => (
                        <tr key={item.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.event_name}</th>
                            <td className="px-6 py-4">{formatDate(item.start_date)}</td>
                            <td className="px-6 py-4">{formatDate(item.end_date)}</td>
                            <td className="px-6 py-4">{item?.bowl_type?.name ?? "-"}</td>
                            <td className="px-6 py-4">
                            <div className="flex gap-2">
                                {item.status == 1 && <button
                                    type="button"
                                    onClick={() => editMenuitem(item.id)}
                                    className="px-3 py-1 text-sm bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">
                                    Edit
                                </button>}
                                {item.status == 1 && canDisable && <button
                                    type="button"
                                    onClick={() => deleteMenuitem(item.id)}
                                    className="px-3 py-1 text-sm bg-red-500 text-white rounded-md hover:bg-red-600 focus:outline-none focus:ring focus:ring-red-200">
                                    Disable
                                </button>}
                                {item.status == 0 && canActivate && <button
                                    type="button"
                                    onClick={() => enableMenuitem(item.id)}
                                    className="px-3 py-1 text-sm bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring focus:ring-green-200">
                                    Enable
                                </button>}
                                {canDelete && <button
                                    type="button"
                                    onClick={() => destroyMenuitem(item.id)}
                                    className="px-3 py-1 text-sm bg-red-700 text-white rounded-md hover:bg-red-800 focus:outline-none focus:ring focus:ring-red-300">
                                    Delete
                                </button>}
                            </div>
                            </td>
                        </tr>))}
           
                    </tbody>
                </table>
            </div>
        </div>
  );
}

export default List;